import React from 'react';
import { observer } from 'src/utils/mobx-react';
import classNames from 'classnames';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { OpenapiProxyStaffAllTransactionsGetListResponse200Type } from 'src/api_openapi/generated/openapi_proxy_staff_all_transactions_get_list';
import { pickMethodLabel, pickTypeLabel } from 'src/components/CustomersBar/CustomerTab/BankingTab/BankingTab';
import { Amount } from 'src_common/common/amount/Amount';
import { getCurrency } from 'src/AppState/sdk/staff';
import { DateTime } from 'src_common/utils/time/time';

type DepositHistoryPropsType = {
    manualAdjustmentsList: Resource<OpenapiProxyStaffAllTransactionsGetListResponse200Type>;
};

export const ManualAdjustments = observer('ManualAdjustments', ({ manualAdjustmentsList }: DepositHistoryPropsType) => {
    const manualAdjusments = manualAdjustmentsList.get();

    return (
        <table>
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Transaction type</th>
                    <th>Payment</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {manualAdjusments.type === 'ready'
                    ? manualAdjusments.value.results.map(
                          ({ amount, tags: { adjustmentType, tradingAdjustment }, assetFlows, id, currency, type }) => {
                              const trading = tradingAdjustment === true ? '(trading)' : '(non-trading)';
                              const convertedAmmout =
                                  type === 'withdrawal' ? new Amount(amount).multiply(-1) : new Amount(amount);
                              return (
                                  <tr key={id}>
                                      <td data-test='manual-adjustments-date'>
                                          {DateTime.from(assetFlows[0]?.date ?? Date.now())?.format('YYYY-MM-DD')}
                                      </td>
                                      <td data-test='manual-adjustments-transaction-type'>{pickTypeLabel(type)}</td>
                                      <td data-test='manual-adjustments-payment'>
                                          {pickMethodLabel(adjustmentType)}{' '}
                                          {adjustmentType === 'manual' ||
                                          adjustmentType === 'casino-bonus' ||
                                          adjustmentType === 'casiono-bonus'
                                              ? trading
                                              : ''}
                                      </td>
                                      <td
                                          data-test='manual-adjustments-amount'
                                          className={classNames({ 'amount--negative': convertedAmmout.isLessThanZero })}
                                      >
                                          {convertedAmmout.format(getCurrency(currency))}
                                      </td>
                                  </tr>
                              );
                          }
                      )
                    : null}
            </tbody>
        </table>
    );
});
